import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from './firebaseapi'
import { PORTAL_USER_TYPES } from '@common/src/constants/constants'

const homePath = `${import.meta.env.BASE_URL}dashboard`

const PublicRoute = ({ children }) => {
  const navigate = useNavigate()
  const [authReady, setAuthReady] = useState(false)
  const [showLogin, setShowLogin] = useState(false)

  // Push a dummy history entry so the browser back button cannot navigate
  // back into a protected page after logout. The popstate listener re-pushes
  // the same entry, keeping the user trapped on the login page until they
  // explicitly authenticate again.
  useEffect(() => {
    window.history.pushState(null, '', window.location.href)

    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href)
    }

    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [])

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setAuthReady(true)
      if (!user) {
        setShowLogin(true)
        return
      }
      try {
        const idTokenResult = await user.getIdTokenResult(true)
        const customClaims = idTokenResult?.claims
        if (PORTAL_USER_TYPES[import.meta.env.VITE_PORTAL]?.includes(customClaims.userType)) {
          navigate(homePath, { replace: true })
        } else {
          setShowLogin(true)
        }
      } catch {
        setShowLogin(true)
      }
    })
    return unsubscribe
  }, [navigate])

  if (!authReady || !showLogin) {
    return null
  }

  return children
}

PublicRoute.propTypes = {
  children: PropTypes.node.isRequired,
}

export default PublicRoute
